// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__sKce6","Main":"Layout_Main__9MwXg"};